import { ButtonVariant, Color, ButtonColor } from 'constants/enums';
import { COLORS, IColor } from '../colors';

type Pallete = {
  [key in ButtonColor]: {
    bgColor: IColor;
    text: IColor;
  };
};

type IButtonConfig = {
  [variant in ButtonVariant]: {
    border: string;
    height: string;
    minWidth: string;
    palette: Pallete;
  };
};

export const button: IButtonConfig = Object.freeze({
  [ButtonVariant.default]: {
    border: 'none',
    height: '48px',
    minWidth: '48px',
    palette: {
      primary: {
        bgColor: COLORS.white,
        text: COLORS.black,
      },
      secondary: {
        bgColor: COLORS.darkGrey,
        text: COLORS.white,
      },
      [Color.black]: {
        bgColor: COLORS.black,
        text: COLORS.white,
      },
      [Color.white]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.darkGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.lightGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.red]: {
        bgColor: COLORS.red,
        text: COLORS.white,
      },
      [Color.grey]: {
        bgColor: COLORS.grey,
        text: COLORS.grey,
      },
    },
  },

  [ButtonVariant.stroke]: {
    border: '2px solid',
    height: '48px',
    minWidth: '48px',
    palette: {
      primary: {
        bgColor: {
          main: 'transparent',
          hover: 'transparent',
          active: 'transparent',
        },
        text: COLORS.red,
      },
      secondary: {
        bgColor: COLORS.white,
        text: COLORS.white,
      },
      [Color.black]: {
        bgColor: COLORS.black,
        text: COLORS.white,
      },
      [Color.white]: {
        bgColor: COLORS.white,
        text: COLORS.white,
      },
      [Color.darkGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.lightGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.red]: {
        bgColor: COLORS.red,
        text: COLORS.red,
      },
      [Color.grey]: {
        bgColor: COLORS.grey,
        text: COLORS.grey,
      },
    },
  },

  [ButtonVariant.none]: {
    border: 'none',
    height: '24px',
    minWidth: 'unset',
    palette: {
      primary: {
        bgColor: {
          main: 'transparent',
          hover: 'transparent',
          active: 'transparent',
        },
        text: COLORS.white,
      },
      secondary: {
        bgColor: COLORS.darkGrey,
        text: COLORS.white,
      },
      [Color.black]: {
        bgColor: COLORS.black,
        text: COLORS.white,
      },
      [Color.white]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.darkGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.lightGrey]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.black,
      },
      [Color.red]: {
        bgColor: COLORS.lightGrey,
        text: COLORS.red,
      },
      [Color.grey]: {
        bgColor: COLORS.grey,
        text: COLORS.grey,
      },
    },
  },
});
